import { render } from "./RegistrationFee.vue?vue&type=template&id=42eecaea&scoped=true&ts=true"
import script from "./RegistrationFee.vue?vue&type=script&lang=ts"
export * from "./RegistrationFee.vue?vue&type=script&lang=ts"

import "./RegistrationFee.vue?vue&type=style&index=0&id=42eecaea&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42eecaea"]])

export default __exports__